import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { ENDPOINT, GO_DE_GQL_BACKEND_URL} from '../../../constants'
import { useAuth } from '../../../contexts/AuthContext'
import { InputField } from '../../../components/InputField';
import { QUERY_COURSES } from '../Courses/query';
import FeaturedCourseCard from '../../../components/FeaturedCourseCard';
import { FetchApi } from '../../../api/fetch';

interface ICourse {
   updatedAt: string;
   subCategoryIds: string[];
   startDate: string;
   projectWebsite: string;
   projectName: string;
   numberOfTicketAward: number;
   name: string;
   maxAttendees: number;
   id: string;
   logoURL: string;
   endDate: string;
   description: string;
   createdAt: string;
   bannerURL: string;
   categoryIds: string[];
   position: number;
}
function FeaturedCourses() {
   const { setIsLoadingOverlayDisplay, getUserJWT } = useAuth()
   const [courses, setCourses] = useState<ICourse[]>([])

   useEffect(() => {
      // getFeatured()
      getCourses()
   }, [])


   const handleSearch = async (e: any) => {
      if (e.target.value?.length > 3) {
         getCourses(e.target.value)
      }
   }
   const getCourses = async (name?: string) => {
      if (!name) {
         setIsLoadingOverlayDisplay(true)
      }

      try {
         const cat = await FetchApi( {
            endpoint:GO_DE_GQL_BACKEND_URL,
            method: "POST",
            body:  ({
               query: QUERY_COURSES,
               variables: { isFeatured: true }
            })
         })
         const sorted = cat?.data?.course?.nodes?.sort((a: any, b: any) => a?.featuredPosition - b?.featuredPosition)
         setCourses(sorted)
      } catch (error) {
         // :TODO
         // add error toast
         console.log(error);

      }
      setIsLoadingOverlayDisplay(false)

   }


   const onDragEnd = (result: any) => {
      // dropped outside the list
      if (!result.destination) {
         return;
      }
      const newItems = [...courses];
      const [reordered] = newItems.splice(result.source.index, 1);
      newItems.splice(result.destination.index, 0, reordered);
      setCourses(newItems)
      saveEntry(reordered, result.destination.index + 1)
   }

   const saveEntry = async (course: any, pos: number) => {
      const userJWT = await getUserJWT()

      const reqBody = {
         id: course.id,
         name: course.name,
         description: course.description,
         project_name: course.projectName,
         project_website: course.projectWebsite,
         number_of_ticket_award: course.numberOfTicketAward,
         max_attendees: course.maxAttendees,
         start_date: course.startDate,
         end_date: course.endDate,
         logo_url: course.logoURL,
         banner_url: course.bannerURL,
         position: course.position,
         featured_position: pos,
         category_id: course.categoryIds,
         sub_category_id: course.subCategoryIds,
         is_featured: course.isFeatured,
         no_max_attendees: course.noMaxAttendees,
         no_expiry: course.noExpiry,
         time_required: course.timeRequired
      }
      try {
         const data = await FetchApi({
            endpoint: ENDPOINT.BASE_ENDPOINT_ACADEMY + `/${course.id}/edit-course`,
            method: "PATCH",
            JWT: userJWT,
            body:  (reqBody)
         })


         if (data.success) {
            toast.success(data.message)
         }
         if (!data.success || data.success === undefined) {
            toast.error(data.message)
         }
      } catch (error: any) {
         toast.error(error.message)
      }

   }

   return (
      <div className='w-11/12 m-auto my-6'>
         <h1 className="font-normal mb-8 text-3xl text-left">
            Featured Courses
         </h1>
         <div>
            <InputField
               type="text"
               defaultValue={''}
               onChange={handleSearch}
               className="w-full  mb-1 mx-0 bg-gray-90 border-gray-80 rounded-full"
               placeholder="Search for course "
            />
         </div>
         <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId='featured'>
               {(provided) => (
                  <div
                     className=''
                     {...provided.droppableProps}
                     ref={provided.innerRef}
                  // style={getListStyle(snapshot.isDraggingOver)}
                  >
                     {
                        courses?.map((item: any, index: number) => (
                           <Draggable key={index} draggableId={item.id || index.toString()} index={index}>
                              {(provided) => (
                                 <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                 >
                                    <FeaturedCourseCard key={1} data={item} getCourses={getCourses} />

                                 </div>
                              )}
                           </Draggable>
                        ))
                     }
                     {provided.placeholder}
                  </div>
               )}
            </Droppable>
         </DragDropContext>
         {courses.length < 1 && <p className='text-xl text-center'>No Courses Found...</p>}
      </div >
   )
}

export default FeaturedCourses